import {Col, Input, message, Modal, Row, Select, Spin} from 'antd';
import moment from "moment/moment";
import React from 'react';
import {connect} from 'react-redux';
import {getCaseIdPlaceholder} from 'utils/org_utils';
import {error_manager} from "../../helper/error_manager";
import {get, post} from "../../helper/request";
import {slideListDeleteSuccess, slideListUpdateSuccess} from '../../redux_actions/slides.action';
import {addSlidesToCase} from "../../utils/api";
import {performAbortControllerCaseSearch} from "../../utils/api";


class MultipleCaseSuggestions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchTerm: '',
            name_suggestions: [],
            selectedCaseID: '',
            confirmLoading: false,
            loadingCaseSearchResults: false,
        }
    }

    closeModal = () => {
        this.setState({confirmLoading: false})
        this.props.closeModal();
    }

    updateCaseSearchResults = (data) => {
        if(data.length > 0){
            const res_list = data;
            let i=0;
            for (i=0; i<res_list.length; i++){
                res_list[i].display_text = res_list[i].display_text.toUpperCase();
            }
            this.setState({
                name_suggestions: res_list,
                loadingCaseSearchResults: false
            });
        }else{
            this.setState({
                name_suggestions: [],
                loadingCaseSearchResults: false
            });
        }
    }

    performCaseSearch = (value) => {
        this.setState({
            searchTerm: value,
            loadingCaseSearchResults: true
        });
        performAbortControllerCaseSearch(value, this.updateCaseSearchResults)
    }

    createCase = (case_id, slides) => {
        this.setState({confirmLoading: true})
        const slide_ids = slides.map((item, index) => item.id);
        let val = {
            case_id: case_id.toUpperCase(),
            patient_name: "",
            age_and_sex: '/',
            receiving_date: new moment().format('YYYY-MM-DD'),
            reporting_date: new moment().format('YYYY-MM-DD'),
            consulting_doctor: '',
            registered_location: '',
            age: '',
            part_designation: '',
            case_type: '',
            slides: slide_ids,
        }
        post(`/api/case/`, val)
            .then(data => {
                slides?.map((slide, index) => {
                    if (this.props.urlState.case_not_assigned) {
                        this.props.dispatch(slideListDeleteSuccess(slide.id));
                    } else {
                        slide.case_id = case_id;
                        this.props.dispatch(slideListUpdateSuccess(slide.id, slide));
                    }
                });
                this.closeModal();
                this.setState({
                    searchTerm: '',
                    name_suggestions: [],
                    selectedCaseID: '',
                });
            })
        .catch(err => {
            error_manager("Failed to create case", err)
        });

    }

    selectCase = (values) => {
        if(values === -1) {
            const slides = this.props.selectedRowKeys.map((item, index) => this.props.allSlides[item]);
            this.createCase(this.state.searchTerm, slides);
        } else {
            if (values.length > 0 || values >= 0) {
                this.setState({
                    selectedCaseID: values,
                    searchTerm: '',
                    name_suggestions: [],
                });
            } else {
                this.setState({
                    searchTerm: '',
                    name_suggestions: [],
                    selectedCaseID: '',
                });
            }
        }
    }

    onBlurAction = (values) => {
        this.setState({
            searchTerm: '',
            name_suggestions: [],
        });
    }

    handleOk = () => {
        if (this.state.selectedCaseID.length > 0) {
            const slides = this.props.selectedRowKeys.map((item, index) => this.props.allSlides[item]);
            this.handleAssignCase(this.state.selectedCaseID, slides);
        } else {
            this.closeModal();
            message.error("Some error occured. Not able to assign a case.", 2.5);
            this.setState({
                searchTerm: '',
                name_suggestions: [],
                selectedCaseID: '',
            });
        }
    }

    handleAssignCase = (case_id, slides) => {
        this.setState({confirmLoading: true})
        addSlidesToCase(case_id, slides)
            .then(response => {
                if (response.status === 200 || response.status === 301 || response.status === 302) {
                    response?.data?.result?.map((item, index) => {
                        if (this.props.urlState.case_not_assigned) {
                            this.props.dispatch(slideListDeleteSuccess(item.id));
                        } else {
                            item.displayOrder = slides.find((slide) => slide.id === item.id).displayOrder;
                            this.props.dispatch(slideListUpdateSuccess(item.id, item));
                        }
                    })
                } else if (response.status === 403 || response.status === 401 || response.status === 400) {
                    message.error("Some error occured. Not able to assign a case.", 2.5);
                    console.log(response);
                }
                this.closeModal()
                this.setState({
                    searchTerm: '',
                    name_suggestions: [],
                    selectedCaseID: '',
                });
            })
            .catch(err => {
                this.closeModal();
                if(err.response.status === 406) {
                    message.error(err.response.data, 2.5);
                } else if (err.response.status === 400 && err.response.data) {
                    message.error(err.response.data, 2.5);
                } else {
                    message.error("Some error occured. Not able to assign a case.", 2.5);
                }
                console.log(err);
                this.setState({
                    searchTerm: '',
                    name_suggestions: [],
                    selectedCaseID: '',
                });
            });
    }

    handleCancel = () => {
        this.closeModal();
        this.setState({
            searchTerm: '',
            name_suggestions: [],
            selectedCaseID: '',
        });
    }

    getAllSelectedSlides = (selectedIds) => {
        return <div className={selectedIds.length > 3 ? "scroll-slide-list-modal" : ""}>
            {selectedIds.map((item, index) => (
                this.props.allSlides[item] ?
                    <div>
                        <Row>
                            <Col span={9} offset={1}>
                                <Input style={{ color: "black", cursor: "default" }}
                                    value={this.state.selectedCaseID}
                                    disabled
                                />
                            </Col>
                            <Col span={13} offset={1}>
                                <Input value={this.props.allSlides[item].name}
                                    style={{ color: "black", cursor: "default" }}
                                    disabled
                                />
                            </Col>
                        </Row>
                        <br />
                    </div>
                : null
            ))}
        </div>
    }

    render() {

        let selected = [];

        let numSuggested = this.state.name_suggestions.length;

        let caseSuggestionsBox =  ( numSuggested > 0 || this.state.loadingCaseSearchResults ) ? (
            <Select.OptGroup label={this.state.loadingCaseSearchResults ?
                <div><Spin size="small"/> <span style={{marginLeft: 5}}>{" Loading results... "}</span></div> :
                <div><b>{numSuggested}</b> result{numSuggested > 1 ? 's' : ''} found </div>}>
                {(this.state.searchTerm.length > 0 && !this.state.loadingCaseSearchResults && this.state.name_suggestions.findIndex((item) => this.state.searchTerm.toUpperCase() === item.display_text)=== -1) &&
                    <Select.Option
                        key={-1}
                        value={-1}
                        label={this.state.searchTerm}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        {<span><b className={'preserve-white-space'}>"{this.state.searchTerm.toUpperCase()}"</b> &nbsp; Create new Case</span>}
                        <span style={{ float: "right", fontSize: 12 }}></span>
                    </Select.Option>
                }
                {this.state.name_suggestions.map((item, index) => (
                    <Select.Option
                        key={index}
                        value={item.display_text}
                        label={item.display_text}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        <span className={'preserve-white-space'}>{item.display_text}</span><span style={{float: "right", fontSize: 12}}></span>
                    </Select.Option>
                ))}
            </Select.OptGroup> ) : this.state.searchTerm.length > 0 ?
            <Select.OptGroup label={"No results found"}>
                <Select.Option
                    key={-1}
                    value={-1}
                    label={this.state.searchTerm}
                    className='search-result-tag'
                    size='small'
                    type='tag'
                >
                    {<span><b className={'preserve-white-space'}>"{this.state.searchTerm.toUpperCase()}"</b> &nbsp; Create new Case</span>}
                    <span style={{ float: "right", fontSize: 12 }}></span>
                </Select.Option>
            </Select.OptGroup> : undefined;

        return (
            <Modal
                title="Add to Folder"
                visible={this.props.modalVisible}
                onOk={this.handleOk}
                confirmLoading={this.state.confirmLoading}
                okText={"Save"}
                onCancel={this.handleCancel}
                okButtonProps={{ disabled: !(this.state.selectedCaseID.length > 0) }}
            >
                <div>
                    <Row>
                        <Col span={9} offset={1}>
                            <b>Current Folder Name</b>
                        </Col>
                        <Col span={12} offset={1}>
                            <b>Slide ID</b>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            {this.getAllSelectedSlides(this.props.selectedRowKeys)}
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col offset={1}>
                            <p>Please enter {getCaseIdPlaceholder()} in the input box below.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col id={'multiple-case-assign-search-select'} className={'custom-dropdown-max-height'} offset={1}>
                            <Select
                                showSearch
                                allowClear
                                autoFocus
                                placeholder={`Enter ${getCaseIdPlaceholder()}`}
                                className="search-input"
                                showArrow={false}
                                filterOption={false}
                                notFoundContent={null}
                                onSearch={this.performCaseSearch}
                                onSelect={this.selectCase}
                                onBlur={this.onBlurAction}
                                optionLabelProp="label"
                                value={selected}
                                getPopupContainer={() => document.getElementById('multiple-case-assign-search-select')}
                            >
                                {caseSuggestionsBox}
                            </Select>
                        </Col>
                    </Row>
                </div>
            </Modal>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        urlState: state.searchReducer,
        allSlides: state.slidesReducer
    }
}

export default connect(mapStateToProps)(MultipleCaseSuggestions);
